import script from "./ShakespeareView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakespeareView.vue?vue&type=script&setup=true&lang=js"

import "./ShakespeareView.vue?vue&type=style&index=0&id=2670dd3b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2670dd3b"]])

export default __exports__